// 어드민 화면의 시각 표기. 보는 사람의 로컬 타임존이 아니라 항상 KST(GMT+9)로 고정해요 —
// 운영자가 어디서 열든 같은 값을 보고, 서버 로그·문의 메일과 대조할 때 어긋나지 않아요.

const KST = "Asia/Seoul";

/** 오프셋이 없는 ISO(`2026-07-27T15:00:00`)를 UTC 로 못박아요.
 *
 * api 는 UTC 로 저장하지만 Mongo 는 타임존을 담지 않아서, 읽어 온 값이 naive 면 오프셋 없는
 * 문자열로 나가요. JS 는 그런 문자열을 **브라우저 로컬 시각**으로 읽어서, 그대로 두면 KST 로
 * 다시 그려도 9시간이 어긋나요. 서버도 `tz_aware=True` 로 오프셋을 붙이지만, 여기서 한 번 더
 * 막아 두면 예전 응답·다른 경로로 온 값도 같은 시각으로 읽혀요.
 * 날짜만 있는 문자열(`2026-07-27`)은 JS 가 이미 UTC 로 읽으니 건드리지 않아요.
 */
const withOffset = (iso: string) =>
  /T\d{2}:\d{2}/.test(iso) && !/(?:Z|[+-]\d{2}:?\d{2})$/.test(iso) ? `${iso}Z` : iso;

/** ISO 문자열을 KST 기준 ko-KR 표기로 바꿔요. `options` 로 자리별 형식을 조절해요. */
export function formatKst(iso: string, options: Intl.DateTimeFormatOptions = {}): string {
  return new Date(withOffset(iso)).toLocaleString("ko-KR", { timeZone: KST, ...options });
}
